import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=2591598b&scoped=true&"
import script from "./CommentDialog.vue?vue&type=script&lang=ts&"
export * from "./CommentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CommentDialog.vue?vue&type=style&index=0&id=2591598b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2591598b",
  null
  
)

export default component.exports